export const FAIR_YEAR_CURRENT_KEY = 'fair-year-current'

export function useFairYearCurrent() {
  const { locale } = useI18n()
  const { $apiFetch } = useNuxtApp()
  const store = useCurrentYearStore()

  return useAsyncData(
    () => `${FAIR_YEAR_CURRENT_KEY}-${locale.value}`,
    async () => {
      const data = await $apiFetch(`/${locale.value}/api/site/fair-years/current/`)
      store.currentYear = data
      return data
    },
    { watch: [locale] },
  )
}
